import Vue from "vue";
import Vuex from "vuex";
import dictionaryStore from "./dictionary.store";
import userStore from "./user.store";
import gameStore from "./game.store";
import sharedStore from "./shared.store";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    dictionaryStore,
    gameStore,
    userStore,
    sharedStore
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js